<template>
  <div>
    <page-title>eForms</page-title>

    <loading v-if="loading" />

    <main class="p-forms-index" v-else>

      <section-block>
        <template slot="header">
          <filter-bar
            resource="Forms"
            :search-query="searchQuery"
            show-search
            show-filter
            :filter-options="orderedCategories"
          ></filter-bar>
        </template>

        <template slot="actions" v-if="$route.meta.isAdmin">
          <base-button
            :primary="true"
            @click="$router.push({ name: 'AdminFormCreatePage' })"
            iconBefore="document-create"
            v-if="userCanAdd"
          >
            <span>Add an eForm</span>
          </base-button>
        </template>
        <base-empty v-if="!forms || forms.length < 1">
          <p>
            There are no eForms created yet.
            <br />Would you like to
            <router-link :to="{ name: 'AdminFormCreatePage' }"
              >create one now</router-link
            >?
          </p>
        </base-empty>

        <vuetable
          v-else
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          detail-row-component="form-detail-row"
          ref="vuetable"
          :data-manager="dataManager"
          track-by="id"
          no-data-template="<br>No documents were found.<br><br>"
          pagination-path
          @vuetable:pagination-data="onPaginationData"
        >
          <template slot="form-name" slot-scope="props">
            <div class="c-data-table__cell-icon">
              <span>{{ props.rowData.current_version.title }}</span>
            </div>
          </template>

          <template slot="form-version" slot-scope="props">
            <div
              class="t-version"
              @click.stop.prevent="toggleDetailRow(props.rowData)"
              v-if="$route.meta.isAdmin && props.rowData.version_count >= 1"
            >
              <base-tooltip fill-container text="See versions">
                <span class="t-version__text">{{
                  props.rowData.current_version.version
                }}</span>
              </base-tooltip>
              <div class="t-version__dropdown">
                <icon name="drop-arrow" width="8" height="8"></icon>
              </div>
            </div>
            <div v-else class="t-version">
              {{ props.rowData.current_version.version }}
            </div>
          </template>

          <template slot="date-created" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>

          <template slot="category-actions" slot-scope="props">
            <category-actions
              routePath="AdminFormEditPage"
              :id="props.rowData.id"
              deleteAction="Forms/delete"
              singular="form"
            >
              <template slot="extra">
                <dropdown-action
                  icon="view"
                  @click="viewEntries(props.rowData.id)"
                  v-if="userCanView(props.rowData)"
                  >View entries</dropdown-action
                >
              </template>
            </category-actions>
          </template>
        </vuetable>
        <pagination table-pagination>
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
      </section-block>
    </main>
  </div>
</template>

<script>
const CategoryActions = () => import("@/components/CategoryActions");
const BaseEmpty = () => import("@/components/elements/BaseEmpty");
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import FormDetailRow from "@/components/FormDetailRow";
import DropdownAction from "@/components/DropdownAction";
import UserHasPermission from "@/mixins/UserHasPermission";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Pagination from "@/components/pagination";
import querySearch from "@/mixins/querySearch";
Vue.component("form-detail-row", FormDetailRow);

export default {
  name: "AdminFormIndexPage",
  components: {
    BaseEmpty,
    CategoryActions,
    DropdownAction,
    VuetablePagination,
    Pagination,
  },
  mixins: [UserHasPermission, querySearch],
  props: {},
  data() {
    return {
      loading: true,
      searchQuery: "",
      // adminTabs: [
      // {
      //   to: `/admin/eforms/`,
      //   title: `Approved`
      // },
      // {
      //   to: `/admin/eforms/pending`,
      //   title: "Awaiting Approval"
      // },
      // {
      //   to: `/admin/eforms/review`,
      //   title: "For Review"
      // },
      // {
      //   to: `/admin/eforms/lapsed`,
      //   title: `Lapsed`
      // },
      // {
      //   to: `/admin/eforms/rejected`,
      //   title: `Rejected`
      // }
      // ],
      table: {
        fields: [
          {
            name: "form-name",
            title: "Form Name",
            titleClass: "u-ta-left",
            dataClass: "u-ta-left title-col",
            width: "50%",
          },
          {
            name: "form-version",
            title: "Version",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass:
              "u-hide-mobile u-ta-center u-pos-relative t-version-wrapper",
            width: "20%",
          },
          // {
          //   name: "category",
          //   titleClass: "u-ta-left",
          //   title: "Category parent",
          //   width: "20%"
          // },
          {
            name: "date-created",
            titleClass: "u-ta-left",
            title: "Date Created",
            width: "20%",
          },
          {
            name: "category-actions",
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "10%",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("Forms", ["forms"]),
    ...mapGetters("FormCategories", ["orderedCategories"]),
    userCanAdd() {
      return this.userHasPermission("add_eforms");
    },
  },
  watch: {},
  beforeCreate() {},
  async created() {
    this.$store.commit("Forms/setSortBy", {
      direction: "desc",
      field: "created_time",
    });
    this.setFiltersFromQuery("Forms");
    await this.$store.dispatch("FormCategories/list", { flat: true });
    await this.$store.dispatch("Forms/list", { flat: true });
    this.loading = false;
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  methods: {
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.Forms.pagination,
        data: this.forms,
      };

      return returnObj;
    },
    onPaginationData(paginationData) {
      paginationData.current_page = this.getCurrentPageNumber('Forms');
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      const vm = this;
      const tableref = vm.$refs.vuetable;
      let nextPage;
      /**
       * Because why would the plugin send actual page numbers
       */
      switch (page) {
        case "next":
          nextPage = ++this.$store.state.Forms.pagination.current_page;
          break;
        case "prev":
          nextPage = --this.$store.state.Forms.pagination.current_page;
          break;
        default:
          nextPage = page;
          break;
      }
      this.updatePageQuery("Forms", nextPage);

      this.$store.dispatch("Forms/list").then((resp) => {
        window.scroll(0, 0);
        tableref.changePage(page);
      });
    },
    toggleDetailRow(dataItem) {
      this.$refs.vuetable.toggleDetailRow(dataItem.id);
    },
    userCanView(row) {
      // if the row is private, only primary and secondary users + creator can view it
      if (row.private) {
        return [
          row.primary_user ? row.primary_user.id : row.primary_user_id,
          row.secondary_user ? row.secondary_user.id : row.secondary_user_id,
          row.created_user ? row.created_user.id : row.created_user_id,
        ].includes(this.$store.state.auth.currentUser.id);
      }
      return true;
    },
    onRowClicked(row) {
      this.$router.push({
        name: "AdminFormEditPage",
        params: { id: row.data.id },
      });
    },
    viewEntries(id) {
      this.$router.push({
        name: "AdminFormEntriesPage",
        params: { id: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.t-version-wrapper {
  padding: 0 !important;
}
.t-version {
  position: relative;

  height: 80px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}
.t-version__dropdown {
  border-left: 1px solid $colour-nhs-pale-grey;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 24px;

  display: flex;
  align-items: center;
  justify-content: center;
}
td > td {
  border: none;
  padding: 0;
  display: inline-block;
}
</style>
